(function() {

'use strict';
var EventEmitter = window.EventEmitter;
var DocViewerEvents = {
    BRIDGE_INITIALIZED : 'BRIDGE_INITIALIZED',
    DRAG_OVER_IN_PROGRESS : 'DRAG_OVER_IN_PROGRESS',
    UPDATE_CONFIGURATION : 'UPDATE_CONFIGURATION',
    TOGGLE_DOCUMENT_SEARCH : 'TOGGLE_DOCUMENT_SEARCH',
    RECEIVE_ANNOTATION_INDEX: 'RECEIVE_ANNOTATION_INDEX',
    DOCUMENT_LOADED : 'DOCUMENT_LOADED',
    RELOAD_ANNOTATIONS : 'RELOAD_ANNOTATIONS',
    RECEIVE_ANNOTATIONS : 'RECEIVE_ANNOTATIONS',

    SET_PDFVIEWER_SCALE : 'SET_PDFVIEWER_SCALE',

    HIDE_ANNOTATIONS: "HIDE_ANNOTATIONS",
    SHOW_ANNOTATIONS: "SHOW_ANNOTATIONS",

    RECEIVE_NEW_ANNOTATIONS : 'RECEIVE_NEW_ANNOTATIONS',
    RECEIVE_ANNOTATION_UPDATES : 'RECEIVE_ANNOTATION_UPDATES',
    DELETE_ANNOTATIONS : 'DELETE_ANNOTATIONS',
    ANNOTATION_DESELECTED_IN_MAIN_WINDOW : 'ANNOTATION_DESELECTED_IN_MAIN_WINDOW',
    ANNOTATION_SELECTED_IN_MAIN_WINDOW : 'ANNOTATION_SELECTED_IN_MAIN_WINDOW',
    ANNOTATION_CREATED_IN_MAIN_WINDOW : 'ANNOTATION_CREATED_IN_MAIN_WINDOW',

    CLICKED_OUTSIDE_IN_PAGE : 'CLICKED_OUTSIDE_IN_PAGE',

    NEW_ANNOTATION_CANCELED_IN_MAIN_WINDOW : 'NEW_ANNOTATION_CANCELED_IN_MAIN_WINDOW',

    //The following 2 events are for loopback
    RENDER_ARROW_FOR_RECTANGLE_SELECTION_IN_PAGE : 'RENDER_ARROW_FOR_RECTANGLE_SELECTION_IN_PAGE',
    RENDER_ARROW_FOR_TEXT_SELECTION_IN_PAGE : 'RENDER_ARROW_FOR_TEXT_SELECTION_IN_PAGE',

    IMMERSIVE_READING_ON : 'IMMERSIVE_READING_ON',
    IMMERSIVE_READING_OFF : 'IMMERSIVE_READING_OFF',
    PAUSE_IMMERSIVE_READING : 'PAUSE_IMMERSIVE_READING',
    RESUME_IMMERSIVE_READING : 'RESUME_IMMERSIVE_READING',

    CUSTOM_PRINT : 'CUSTOM_PRINT',
    PRESENTATION_MODE_CHANGED : 'PRESENTATION_MODE_CHANGED',

    RECTANGLE_SELECTION_STARTED_IN_PAGE : 'RECTANGLE_SELECTION_STARTED_IN_PAGE',
    TEXT_SELECTION_STARTED_IN_PAGE : 'TEXT_SELECTION_STARTED_IN_PAGE',

    TEXT_SELECTED_IN_PAGE : 'TEXT_SELECTED_IN_PAGE',

    ANNOTATION_UNSELECTED_IN_PAGE  : 'ANNOTATION_UNSELECTED_IN_PAGE',
    ANNOTATION_SELECTED_IN_PAGE: 'ANNOTATION_SELECTED_IN_PAGE',
    SCROLLED_TO_PAGE: 'SCROLLED_TO_PAGE',

    RECTANGLE_DRAWN_IN_PAGE: 'RECTANGLE_DRAWN_IN_PAGE',
    GET_CURRENT_PAGE_ASPECT_RATIO: 'GET_CURRENT_PAGE_ASPECT_RATIO',
    RETURN_CURRENT_PAGE_ASPECT_RATIO: 'RETURN_CURRENT_PAGE_ASPECT_RATIO'
};

function convertToLowerCasePoint(point) {
    return {
        x : point.X,
        y : point.Y
    };
}

function DocViewerBridge(currentContext) {
    EventEmitter.call(this);
    this.feedbackFakeIdToRealIdMap = {};
    this.feedbackRealIdToFakeIdMap = {};
    this.initialized = false;
    this.reinitialized = false;
    this.setupListener = false;
    this.currentContext = currentContext;

    this.processBottomUpMessage = this.processBottomUpMessage.bind(this);
}

_.inherit(DocViewerBridge, EventEmitter);

var proto = DocViewerBridge.prototype;
proto.init = function(docViewerContext) {
    this.docViewerContext = docViewerContext;
    if (!this.setupListener) {
        this.setupListener = true;
        //Do not setup listeners twice, you'll be called twice :)
        this.currentContext.addEventListener('message', this.processBottomUpMessage, false);
    } else {
        this.reinitialized = true;
    }
    this.initialized = false;
};

/**
 * This method will destroy the bridge layer that listens to the messages emitted on the window.
 * It is important to call this destroy() when the Document viewer scope is destroyed, i.e., when another document is loaded or user navigating away from
 * "#/document/resource-hash-code" route. Otherwise multiple bridges will interfere with annotation rendering
 */
proto.destroy = function() {
    this.currentContext.removeEventListener('message', this.processBottomUpMessage, false);
};

proto.processBottomUpMessage = function(evt) {
    var me = this;
    if (evt.data.type === DocViewerEvents.BRIDGE_INITIALIZED) {
        me.initialized = true;
        if (me.messageQueue) {
            me.messageQueue.forEach(function(message) {
                me.postMessage(message);
            });
            //Empty out the messageQueue so the same messages do not go out if the
            //docviewer frame were to send BRIDGE_INITIALIZED event again
            me.messageQueue = [];
        }
        me.emit(DocViewerEvents.BRIDGE_INITIALIZED);
    }

    //When the bridge is reinitialized, and document is loaded reload the annotations
    if (me.reinitialized && evt.data.type === DocViewerEvents.DOCUMENT_LOADED) {
        me.emit(DocViewerEvents.RELOAD_ANNOTATIONS);
    }

    me.processPayload(evt.data);
    me.emit(evt.data.type, evt.data);
};

/**
 * We might want to process the payload before we emit the change to the listener,
 * Cases include, when we want to normalize the capital X,Y to smaller x,y and vice versa
 */
proto.processPayload = function(action) {
    var type = action.type,
        payload = action.payload;
    switch (type) {
        case DocViewerEvents.TEXT_SELECTION_STARTED_IN_PAGE:
        case DocViewerEvents.RECTANGLE_SELECTION_STARTED_IN_PAGE:
        case DocViewerEvents.TEXT_SELECTED_IN_PAGE:
        case DocViewerEvents.RECTANGLE_DRAWN_IN_PAGE:
            payload.regions = (payload.regions || []).map(function(region) {
                return {
                    TopLeft : {
                        X : region.TopLeft.x,
                        Y : region.TopLeft.y
                    },
                    BottomRight : {
                        X : region.BottomRight.x,
                        Y : region.BottomRight.y
                    }
                };
            });
            break;

        case DocViewerEvents.ANNOTATION_SELECTED_IN_PAGE:
            if (this.feedbackFakeIdToRealIdMap[payload.AnnotationId]) {
                payload.AnnotationId = this.feedbackFakeIdToRealIdMap[payload.AnnotationId];
            }
            break;
    }
};

/**
 * DocumentViewerBridge maintains an internal map of draft vs actual feedback IDs (AnnotationIDs and CommentIDs)
 */
proto.updateAnnotationIds = function(oldVsNewAnnotationIds) {
    this.feedbackFakeIdToRealIdMap = angular.extend(this.feedbackFakeIdToRealIdMap, oldVsNewAnnotationIds);
    var newObj = {};
    angular.forEach(oldVsNewAnnotationIds, function(realId, oldId) {
        newObj[realId] = oldId; //reverse mapping
    });
    this.feedbackRealIdToFakeIdMap = angular.extend(this.feedbackRealIdToFakeIdMap, newObj);
};

proto.postMessage = function(message) {
    var ctx = this.docViewerContext;
    if (!this.initialized) {
        if (!this.messageQueue) {
            this.messageQueue = [];
        }
        this.messageQueue.push(message);
    }
    if (!ctx) {
        return;
    }
    ctx.postMessage(message, "*"); //* means no preference for target origin
};

proto.newAnnotationCanceled = function() {
    this.postMessage({
        type : DocViewerEvents.NEW_ANNOTATION_CANCELED_IN_MAIN_WINDOW,
        payload : {}
    });
};

proto.pauseImmersiveReading = function() {
    this.postMessage({
        type : DocViewerEvents.PAUSE_IMMERSIVE_READING,
        payload : {}
    });
};

proto.resumeImmersiveReading = function() {
    this.postMessage({
        type : DocViewerEvents.RESUME_IMMERSIVE_READING,
        payload : {}
    });
};

proto.updateConfiguration = function(cfg) {
    //Convert annotation ids here
    this.postMessage({
        type : DocViewerEvents.UPDATE_CONFIGURATION,
        payload : cfg
    });
};

proto.receiveAnnotationUpdates = function(pageVsAnnotationList) {
    var me = this;
    pageVsAnnotationList = angular.copy(pageVsAnnotationList);
    angular.forEach(pageVsAnnotationList, function(annotationList, pageNumber) {
        annotationList.forEach(function(annotation) {
            annotation.AnnotationId = me.convertAnnotationId(annotation.AnnotationId);
        });
    });
    //Convert annotation ids here
    this.postMessage({
        type : DocViewerEvents.RECEIVE_ANNOTATION_UPDATES,
        payload : pageVsAnnotationList
    });
};

proto.hideAnnotations = function() {
    this.postMessage({
        type : DocViewerEvents.HIDE_ANNOTATIONS,
        payload : {}
    });
};


proto.showAnnotations = function() {
    this.postMessage({
        type : DocViewerEvents.SHOW_ANNOTATIONS,
        payload : {}
    });
};

proto.toggleDocumentSearch = function() {
    this.postMessage({
        type: DocViewerEvents.TOGGLE_DOCUMENT_SEARCH,
        payload : {}
    });
};

proto.convertAnnotationId = function(AnnotationId) {
    if (this.feedbackRealIdToFakeIdMap[AnnotationId]) {
        return this.feedbackRealIdToFakeIdMap[AnnotationId];
    }
    return AnnotationId;
};

proto.receiveAnnotations = function(annotationsListMap) {
    var me = this;
    var newMap = angular.copy(annotationsListMap);
    angular.forEach(newMap, function(annotationList, pageNumber) {
        angular.forEach(annotationList, function(annotation, key2) {
            if (annotation.AnnotationStatus === 'DELETED') {
                annotation.AnnotationStatus = 'PUBLISHED';
            }
            annotation.AnnotationId = me.convertAnnotationId(annotation.AnnotationId);
            annotation.Regions = annotation.Regions.map(function(Region) {
                return {
                    TopLeft : convertToLowerCasePoint(Region.TopLeft),
                    BottomRight : convertToLowerCasePoint(Region.BottomRight)
                };
            });
        });
    });
    this.postMessage({
        type: DocViewerEvents.RECEIVE_ANNOTATIONS,
        payload : newMap
    });
};

proto.receiveNewAnnotations = function(annotationsListMap) {
    var me = this;
    var newMap = angular.copy(annotationsListMap);
    angular.forEach(newMap, function(annotationList, pageNumber) {
        angular.forEach(annotationList, function(annotation, key2) {
            annotation.AnnotationId = me.convertAnnotationId(annotation.AnnotationId);
            annotation.Regions = annotation.Regions.map(function(Region) {
                return {
                    TopLeft : convertToLowerCasePoint(Region.TopLeft),
                    BottomRight : convertToLowerCasePoint(Region.BottomRight)
                };
            });
        });
    });
    this.postMessage({
        type: DocViewerEvents.RECEIVE_NEW_ANNOTATIONS,
        payload : annotationsListMap
    });
};

proto.deleteAnnotations = function(annotationIDsListMap) {
    var me = this;
    angular.forEach(annotationIDsListMap, function(idsList, key) {
        annotationIDsListMap[key] = idsList.map(me.convertAnnotationId.bind(me));
    });
    this.postMessage({
        type: DocViewerEvents.DELETE_ANNOTATIONS,
        payload : annotationIDsListMap
    });
};

proto.annotationSelected  = function(pageNumber, annotation, boundingClientRect) {
    annotation = angular.copy(annotation);
    annotation.AnnotationId = this.convertAnnotationId(annotation.AnnotationId);
    this.postMessage({
        type: DocViewerEvents.ANNOTATION_SELECTED_IN_MAIN_WINDOW,
        payload : {
            pageNumber: pageNumber,
            boundingClientRect: boundingClientRect,
            annotation : annotation
        }
    });
};

proto.renderArrowForTextSelection = function(pageNumber, boundingClientRect) {
    this.postMessage({
        type: DocViewerEvents.RENDER_ARROW_FOR_TEXT_SELECTION_IN_PAGE,
        payload : {
            pageNumber : pageNumber,
            boundingClientRect : boundingClientRect
        }
    });
};

proto.annotationCreated = function(pageNumber, newAnnotation) {
    newAnnotation = angular.copy(newAnnotation);
    newAnnotation.AnnotationId = this.convertAnnotationId(newAnnotation.AnnotationId);
    newAnnotation.Regions = newAnnotation.Regions.map(function(Region) {
        return {
            TopLeft : convertToLowerCasePoint(Region.TopLeft),
            BottomRight : convertToLowerCasePoint(Region.BottomRight)
        };
    });
    this.postMessage({
        type: DocViewerEvents.ANNOTATION_CREATED_IN_MAIN_WINDOW,
        payload : {
            pageNumber : pageNumber,
            annotation: newAnnotation
        }
    });
};

proto.renderArrowForRectangleSelection = function(pageNumber, boundingClientRect) {
    this.postMessage({
        type: DocViewerEvents.RENDER_ARROW_FOR_RECTANGLE_SELECTION_IN_PAGE,
        payload : {
            pageNumber : pageNumber,
            boundingClientRect : boundingClientRect
        }
    });
};

proto.receiveAnnotationIdex = function(index) {
    this.postMessage({
        type: DocViewerEvents.RECEIVE_ANNOTATION_INDEX,
        payload : index
    });
};

proto.annotationDeselected  = function() {
    this.postMessage({
        type: DocViewerEvents.ANNOTATION_DESELECTED_IN_MAIN_WINDOW,
        payload : {}
    });
};

proto.setPDFViewerScale = function(scale) {
    this.postMessage({
        type: DocViewerEvents.SET_PDFVIEWER_SCALE,
        payload: {
            scale: scale
        }
    });
};

proto.getCurrentPageAspectRatio = function() {
    this.postMessage({
        type: DocViewerEvents.GET_CURRENT_PAGE_ASPECT_RATIO,
        payload: {}
    });
};

window.DocViewerBridge = DocViewerBridge;
window.DocViewerEvents = DocViewerEvents;

}());
